import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#each this.parts as |part|}}\n  {{~#if (has-block)~}}\n    {{part.connector}}{{yield part.value}}\n  {{~else~}}\n    {{part.connector}}{{part.value}}\n  {{~/if~}}\n{{/each}}", {
  moduleName: "@dashboard/shared-ui/components/joined-list.hbs"
});